import { Modal, Spin } from 'antd'

import './Dialog.css'

const Dialog = ({
  title,
  className,
  isVisible,
  footerActions,
  onOk,
  onCancel,
  children,
  isLoading,
  image,
  ...other
}) => {
  const getTitle = () => {
    return (
      <div className="dialog-title">
        {image && (
          <div className="dialog-title-image">
            <img src={image} alt="dialog-title" />
          </div>
        )}
        <div className="dialog-title-text">{title}</div>
      </div>
    )
  }

  return (
    <Modal
      wrapProps={{ onClick: e => e?.stopPropagation() }}
      className={'dialog-modal ' + className}
      title={isLoading ? null : getTitle()}
      width={1000}
      centered
      open={isVisible}
      onOk={onOk}
      onCancel={onCancel}
      footer={isLoading ? null : footerActions}
      onMouseOver={e => console.log('sdfsdf', e)}
      closeIcon={<i className="icon-oclose close-btn" />}
      {...other}
    >
      {isLoading && <Spin className="loading" size="large" />}
      {!isLoading && children}
    </Modal>
  )
}

export default Dialog
